import { render, staticRenderFns } from "./ArticleRead.vue?vue&type=template&id=b841931a&scoped=true"
import script from "./ArticleRead.vue?vue&type=script&lang=js"
export * from "./ArticleRead.vue?vue&type=script&lang=js"
import style0 from "./ArticleRead.vue?vue&type=style&index=0&id=b841931a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b841931a",
  null
  
)

export default component.exports